import React from "react";
import { useStoredItem } from "../../../state/InternalContext";

interface ItemPositionProps {
    item: string,
}

/***
 * A source component that returns the position of a stored item.
 * 
 * Params:
 *      store: The name of the store
 */
export const ItemPosition = React.memo(function ItemPosition({ item }: ItemPositionProps): React.ReactElement {
    const storedItem = useStoredItem(item);
    return <>{storedItem?.position || 0}</>;
});